import { Entity } from '@backstage/catalog-model';

export const serializeClusterEntity = (entity: Entity) => {
  return {
    id: `${entity.kind}:${entity.metadata.namespace || 'default'}/${
      entity.metadata.name
    }`,
    name: entity.metadata.name,
    title: entity.metadata.title || entity.metadata.name,
    isDaaSAuthorized:
      entity.metadata.annotations?.['tomtom.com/daas-authorized'] === 'true',
    subscriptionId: entity.metadata.annotations?.['azure.com/subscription-id'],
    resourceGroup: entity.metadata.annotations?.['azure.com/resource-group'],
  };
};
